import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { NewsDataFilter } from "../../../data/reports/news/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const NewsFilterChips: React.FunctionComponent<NewsFilterChipsProps> = ({
  filter,
  removefilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);

  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removefilter("dateto")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface NewsFilterChipsProps {
  filter: NewsDataFilter;
  removefilter: (type: keyof NewsDataFilter) => void;
}
